<ul class="lista-seleccionable">
    <ng-container *ngFor="let estudiante of listas.estudiantes">
        <li class="item-lista" (click)="seleccionarEstudiante(estudiante)">{{ estudiante.primer_nombre }} {{ estudiante.segundo_nombre }} {{ estudiante.primer_apellido }} {{ estudiante.segundo_apellido }}</li>
    </ng-container>
</ul>